<template>
    <icon-base v-bind="$props">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M7 9l3 3l-3 3" />
        <path d="M13 15h4" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
